import { DateRange, StaticDateRangePicker } from "@mui/x-date-pickers-pro";
import FilterDropdown from "components/filters/FilterDropdown";
import { useState } from "react";
import { formatDateUTC } from "util/util";

export default function DateRangeFilter({
  name,
  value,
  setValue,
}: {
  name: string;
  value: DateRange<Date>;
  setValue: (range: DateRange<Date>) => void;
}) {
  const active = value[0] !== null && value[1] !== null;
  const displayName = active
    ? formatDateUTC(value[0] as Date) + " - " + formatDateUTC(value[1] as Date)
    : name;
  const [date, setDate] = useState<DateRange<Date>>(value);
  const onClear = (close: () => void) => {
    close();
    setValue([null, null]);
  };
  const onSubmit = (close: () => void) => {
    close();
    setValue(date);
  };

  return (
    <FilterDropdown
      name={displayName}
      onSubmit={onSubmit}
      onClear={onClear}
      active={active}
    >
      <label className="block font-medium text-gray-700">
        {name}
        <StaticDateRangePicker
          displayStaticWrapperAs="desktop"
          calendars={1}
          value={date}
          onChange={(range: DateRange<Date>) => setDate(range)}
          maxDate={new Date()}
          closeOnSelect={false}
          renderInput={() => <span />}
        />
      </label>
    </FilterDropdown>
  );
}
